import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router'

import createImageUrl from '../createImageUrl'

import Icon from '../../../shared/components/Icon'
import getPath from '../../../shared/utils/getPath'
import { imagesByType } from '../../../shared/utils/images'

function dashCase(str) {
  return str.replace(/[A-Z]\S/g, (match) => {
    return `-${match.toLowerCase()}`
  })
}

export default class ListItem extends Component {

  static propTypes = {
    entry: PropTypes.object.isRequired
  }

  render() {
    const {
      entry: {
        type, id, title, subtitle, images,
      },
      faded,
      fadedReason
    } = this.props

    const { bannerImage } = imagesByType(images)

    return (
      <li className={[type, (faded ? 'faded' : '')].join(' ')}>
        <Link to={getPath('frontend', dashCase(type), id)}>
          <span
            className="banner"
            style={{ backgroundImage: bannerImage ? `url(${createImageUrl(bannerImage, 200)})` : '' }}
          />
          <div className="title">{title}</div>
          <small className="subtitle">
            (
            {subtitle}
            )
          </small>
          {fadedReason ? (
            <div className="faded-info" title={fadedReason}>
              <Icon
                name="virus-turquoise"
                size="26"
              />
            </div>
          ) : null}
        </Link>
      </li>
    )
  }

}



// WEBPACK FOOTER //
// ./src/frontend/shared/components/ListEntry.js